import * as moment from 'moment';
import { extendMoment } from 'moment-range';

export default function (year = +moment().format('YYYY'), month = +moment().format('MM') - 1, outputFormat = 'DD') {
  const extMoment = extendMoment(moment);
  const startDate = extMoment([year, month]);

  const firstDay = extMoment(startDate).startOf('month');
  const endDay = extMoment(startDate).endOf('month');

  const monthRange = extMoment.range(firstDay, endDay);
  const weeks = [];
  const days = Array.from(monthRange.by('day'));
  days.forEach((it) => {
    if (!weeks.includes(it.week())) {
      weeks.push(it.week());
    }
  });

  const calendar = [];
  weeks.forEach((week) => {
    const firstWeekDay = extMoment([year, month]).week(week).day(1);
    const lastWeekDay = extMoment([year, month]).week(week).day(7);
    const weekRange = extMoment.range(firstWeekDay, lastWeekDay);
    calendar.push(Array.from(weekRange.by('day')).map((m) => m.format(outputFormat)));
  });

  return calendar;
}
